import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useAuthStore } from '../../auth/stores/authStore';

export const allocationDetailsKeys = {
  all: ['allocationDetails'] as const,
  details: () => [...allocationDetailsKeys.all, 'detail'] as const,
  detail: (allocationId: string, isAuthenticated: boolean) =>
    [
      ...allocationDetailsKeys.details(),
      { allocationId, isAuthenticated },
    ] as const,
};

/**
 * Hook to fetch allocation summary details
 */
export function useAllocationDetails(allocationId: string | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  const { data, error, isFetching } = useQuery({
    queryKey: allocationDetailsKeys.detail(allocationId || '', isAuthenticated),
    queryFn: async ({ signal }) => {
      if (!allocationId) {
        return null;
      }
      const response = unwrap(
        await api.legacy.GET('/api/v1/allocations/{allocationId}/summary', {
          params: { path: { allocationId } },
          signal,
        })
      );
      return response.allocation;
    },
    enabled: isAuthenticated && !!allocationId,
    staleTime: 30000,
  });

  return { data, error, isFetching };
}
